import { ArrowRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { useLeadModal } from "../components/LeadModal";
import { WhatsAppIcon } from "../components/WhatsAppFloat";
import { WHATSAPP_URL } from "@/lib/api";

export const FinalCTA = () => {
  const { openModal } = useLeadModal();

  return (
    <section className="relative px-5 pb-24 pt-10 sm:px-8 lg:pb-32" data-testid="final-cta-section">
      <Reveal>
        <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[2.5rem] bg-brand px-8 py-20 sm:px-12 lg:py-24">
          <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-white/10" />
          <div className="pointer-events-none absolute -bottom-32 -left-24 h-96 w-96 rounded-full bg-petrol/20" />
          <div className="relative flex flex-col items-start justify-between gap-10 lg:flex-row lg:items-center">
            <div className="max-w-xl">
              <h2 className="font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
                Vamos resolver?
              </h2>
              <p className="mt-4 text-base leading-relaxed text-white/80 sm:text-lg">
                Conte para a gente o que precisa ser resolvido. O resto deixa com a Resolv.
              </p>
            </div>
            <div className="flex flex-col gap-4 sm:flex-row lg:flex-col xl:flex-row">
              <button
                onClick={() => openModal()}
                data-testid="final-cta-request-button"
                className="group inline-flex h-14 items-center justify-center gap-2 whitespace-nowrap rounded-full bg-white px-9 font-display text-base font-bold text-brand transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_20px_44px_-12px_rgba(0,0,0,0.35)]"
              >
                Solicitar atendimento
                <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
              </button>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="final-cta-whatsapp-button"
                className="inline-flex h-14 items-center justify-center gap-2.5 whitespace-nowrap rounded-full border-2 border-white/40 px-9 font-display text-base font-bold text-white transition-[background-color,border-color,transform] duration-300 hover:-translate-y-1 hover:border-white hover:bg-white/10"
              >
                <WhatsAppIcon className="h-5 w-5" />
                Falar com a Resolv
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
};
